"use client";

import type { FormEvent } from "react";
import { BUSINESS } from "../config/business";

const ContactForm = () => {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const name = String(formData.get("name") || "").trim();
    const email = String(formData.get("email") || "").trim();
    const phone = String(formData.get("phone") || "").trim();
    const service = String(formData.get("service") || "").trim();
    const message = String(formData.get("message") || "").trim();

    const quoteMessage = [
      `Hi ${BUSINESS.siteName}, I would like a quote.`,
      `Name: ${name}`,
      `Phone: ${phone}`,
      email ? `Email: ${email}` : "",
      `Service: ${service}`,
      `Requirement: ${message}`,
    ]
      .filter(Boolean)
      .join("\n");

    window.open(
      `${BUSINESS.whatsappUrl}?text=${encodeURIComponent(quoteMessage)}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <div className="h-full rounded-2xl border border-[#7DD3FC]/55 bg-white p-8 text-[#475569] shadow-[0_20px_55px_rgba(3,105,161,0.12)]">

      <h2 className="mb-6 bg-gradient-to-r from-[#0369A1] via-[#0C4A6E] to-[#0369A1] text-center text-2xl font-bold
        bg-clip-text text-transparent">
        Send Us a Message
      </h2>

      <form className="space-y-5" onSubmit={handleSubmit}>

        {/* Full Name */}
        <div>
          <label htmlFor="quote-name" className="mb-1 block font-medium text-[#334155]">
            Full Name
          </label>
          <input
            id="quote-name"
            name="name"
            type="text"
            placeholder="Your Name"
            required
            autoComplete="name"
            className="w-full rounded-xl border border-[#BAE6FD] bg-[#F0F9FF] px-4 py-3 text-[#0F172A] outline-none placeholder:text-[#64748B] focus:border-[#0369A1] focus:ring-2 focus:ring-[#7DD3FC]"
          />
        </div>

        {/* Email */}
        <div>
          <label htmlFor="quote-email" className="mb-1 block font-medium text-[#334155]">
            Email
          </label>
          <input
            id="quote-email"
            name="email"
            type="email"
            placeholder="Your Email"
            autoComplete="email"
            className="w-full rounded-xl border border-[#BAE6FD] bg-[#F0F9FF] px-4 py-3 text-[#0F172A] outline-none placeholder:text-[#64748B] focus:border-[#0369A1] focus:ring-2 focus:ring-[#7DD3FC]"
          />
        </div>

        {/* Phone */}
        <div>
          <label htmlFor="quote-phone" className="mb-1 block font-medium text-[#334155]">
            Phone Number
          </label>
          <input
            id="quote-phone"
            name="phone"
            type="tel"
            placeholder="Your Phone Number"
            required
            autoComplete="tel"
            className="w-full rounded-xl border border-[#BAE6FD] bg-[#F0F9FF] px-4 py-3 text-[#0F172A] outline-none placeholder:text-[#64748B] focus:border-[#0369A1] focus:ring-2 focus:ring-[#7DD3FC]"
          />
        </div>

        <div>
          <label htmlFor="quote-service" className="mb-1 block font-medium text-[#334155]">
            Service
          </label>
          <select
            id="quote-service"
            name="service"
            required
            defaultValue=""
            className="w-full rounded-xl border border-[#BAE6FD] bg-[#F0F9FF] px-4 py-3 text-[#0F172A] outline-none focus:border-[#0369A1] focus:ring-2 focus:ring-[#7DD3FC]"
          >
            <option value="" disabled>Select a service</option>
            <option>Invisible Grills</option>
            <option>Balcony Safety Nets</option>
            <option>Pigeon Safety Nets</option>
            <option>Children Safety Nets</option>
            <option>Pet Safety Nets</option>
            <option>Bird Spikes</option>
            <option>Construction or Industrial Nets</option>
            <option>Other Safety Net Service</option>
          </select>
        </div>

        {/* Message */}
        <div>
          <label htmlFor="quote-message" className="mb-1 block font-medium text-[#334155]">
            Location and requirement
          </label>
          <textarea
            id="quote-message"
            name="message"
            rows={4}
            placeholder="Area, opening type, approximate size and preferred visit time"
            required
            className="w-full rounded-xl border border-[#BAE6FD] bg-[#F0F9FF] px-4 py-3 text-[#0F172A] outline-none placeholder:text-[#64748B] focus:border-[#0369A1] focus:ring-2 focus:ring-[#7DD3FC]"
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full rounded-xl bg-[#0369A1] py-3 font-bold text-white shadow-lg transition duration-300 hover:scale-[1.02] hover:bg-[#075985] hover:shadow-sky-900/25"
        >
          Send Quote Request on WhatsApp
        </button>

      </form>
    </div>
  );
};

export default ContactForm;
